<template>
  <div class="WordSection1">
    <p
      class="MsoNormal"
      align="center"
      style="text-align:center;mso-pagination:widow-orphan;
background:white"
    >
      <span lang="EN-US" style='font-size:18.0pt;font-family:"Arial",sans-serif'
        >GF-7 Satellite</span
      >
    </p>
    <hr class="divider" />

    <p
      class="MsoNormal"
      align="center"
      style="text-align:center;mso-pagination:widow-orphan;
background:white"
    >
      <span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;font-family:
"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt;
mso-no-proof:yes'
        ><img
          width="500"
          height="300"
          src="../../assets/gf7sat.png"
          v:shapes="图片_x0020_1"/></span
      ><span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;font-family:"微软雅黑",sans-serif;
mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt'
        ><o:p></o:p
      ></span>
    </p>

    <p
      class="MsoNormal"
      align="left"
      style="margin-right:38.3pt;mso-para-margin-right:
3.65gd;text-align:left;text-indent:24.0pt;line-height:21.0pt;mso-pagination:
widow-orphan;background:white"
    >
      <span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;
font-family:"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:
0pt'
        >GF-7 satellite was successfully launched on 3 Nov 2019. Its lead user
        is the Ministry of Natural Resources of P. R. China (MNR), and it also
        serves other users, such as Ministry of Housing and Urban-Rural
        Development of
        <span class="SpellE">P.<span class="GramE">R.China</span></span
        >(MOHURD) and the National Bureau of Statistics(NBS).<o:p></o:p
      ></span>
    </p>

    <p
      class="MsoNormal"
      align="left"
      style="margin-right:38.3pt;mso-para-margin-right:
3.65gd;text-align:left;text-indent:24.0pt;line-height:21.0pt;mso-pagination:
widow-orphan;background:white"
    >
      <span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;
font-family:"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:
0pt'
        >GF-7 satellite runs on the sun-synchronous orbit and has a designed
        life of 8 years. The two-line stereo camera can effectively obtain 20
        km-width panchromatic stereo images with resolution better than 0.8m and
        3.2m-resolution multispectral images; the equipped two-beam laser
        altimeter can perform Earth observation at 3Hz observation frequency,
        with ground footprint diameter less than 30m, and acquire full waveform
        data at a sampling frequency higher <span class="SpellE">tan</span> 1
        GHz. Through the composite mapping mode of stereo camera and laser
        altimeter, the satellite realizes 1:10000-scale stereo mapping, serving
        the application needs of natural resource survey monitoring, basic
        surveying and mapping, and global geo-information resource construction,
        and providing high-precision satellite remote sensing images for the
        fields of housing and urban rural development as well as national survey
        statistics.<o:p></o:p
      ></span>
    </p>

    <p
      class="MsoNormal mt-1"
      align="left"
      style="text-align:left;mso-pagination:widow-orphan;
background:white"
    >
      <b
        ><span
          lang="EN-US"
          style='font-size:12.0pt;font-family:"微软雅黑",sans-serif;
mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt'
          >Orbit parameters<o:p></o:p></span
      ></b>
    </p>

    <table
      class="MsoNormalTable"
      border="1"
      cellspacing="0"
      cellpadding="0"
      style="width:95%;border-collapse:collapse;border:none;mso-border-alt:solid #DDDFE4 .75pt;
 mso-yfti-tbllook:1184"
    >
      <thead>
        <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes">
          <td
            style="border:solid #DDDFE4 1.0pt;mso-border-alt:solid #DDDFE4 .75pt;
   background:#C1CCE4;padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                  >Item<o:p></o:p></span
              ></b>
            </p>
          </td>
          <td
            style="border:solid #DDDFE4 1.0pt;border-left:none;mso-border-left-alt:
   solid #DDDFE4 .75pt;mso-border-alt:solid #DDDFE4 .75pt;background:#C1CCE4;
   padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;color:black;mso-color-alt:
   windowtext;mso-font-kerning:0pt"
                  >Parameter</span
                ></b
              ><b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
   mso-font-kerning:0pt"
                  ><o:p></o:p></span
              ></b>
            </p>
          </td>
        </tr>
      </thead>
      <tr style="mso-yfti-irow:1">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Launch Vehicle<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >CZ<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:2">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Launch Location<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Taiyuan Satellite Launch Center<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:3">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Orbital Type<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Sun-synchronous<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:4">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Orbital Altitude<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >500 kilometers<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:5">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Revisit Cycle<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >≤60 days<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:6;mso-yfti-lastrow:yes">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Designed Life<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >8 years<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
    </table>

    <p
      class="mt-5"
      align="left"
      style="text-align:left;mso-pagination:widow-orphan;
background:white"
    >
      <b
        ><span
          lang="EN-US"
          style='font-size:12.0pt;font-family:"微软雅黑",sans-serif;
mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt'
          >Sensor technical parameters<o:p></o:p></span
      ></b>
    </p>

    <table
      class="MsoNormalTable"
      border="1"
      cellspacing="0"
      cellpadding="0"
      style="width:95%;border-collapse:collapse;border:none;mso-border-alt:solid #DDDFE4 .75pt;
 mso-yfti-tbllook:1184"
    >
      <thead>
        <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes">
          <td
            style="border:solid #DDDFE4 1.0pt;mso-border-alt:solid #DDDFE4 .75pt;
   background:#C1CCE4;padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                  >Sensor<o:p></o:p></span
              ></b>
            </p>
          </td>
          <td
            style="border:solid #DDDFE4 1.0pt;border-left:none;mso-border-left-alt:
   solid #DDDFE4 .75pt;mso-border-alt:solid #DDDFE4 .75pt;background:#C1CCE4;
   padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;color:black;mso-color-alt:
   windowtext;mso-font-kerning:0pt"
                  >Item</span
                ></b
              ><b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
   mso-font-kerning:0pt"
                  ><o:p></o:p></span
              ></b>
            </p>
          </td>
          <td
            width="336"
            colspan="2"
            style="width:251.65pt;border:solid #DDDFE4 1.0pt;
   border-left:none;mso-border-left-alt:solid #DDDFE4 .75pt;mso-border-alt:
   solid #DDDFE4 .75pt;background:#C1CCE4;padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;color:black;mso-color-alt:
   windowtext;mso-font-kerning:0pt"
                  >Parameter</span
                ></b
              ><b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
   mso-font-kerning:0pt"
                  ><o:p></o:p></span
              ></b>
            </p>
          </td>
        </tr>
      </thead>
      <tr style="mso-yfti-irow:1;height:44.95pt">
        <td
          rowspan="10"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt;
  height:44.95pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Bi-linear array stereo camera<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          rowspan="5"
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt;height:44.95pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral Bands<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt;height:44.95pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Pan<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt;height:44.95pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.45</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.90 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:2">
        <td
          rowspan="4"
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >MS<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="295"
          style="width:221.6pt;border-top:none;border-left:none;
  border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.45</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.52 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:3;height:23.6pt">
        <td
          width="295"
          style="width:221.6pt;border-top:none;border-left:none;
  border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt;
  height:23.6pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.52</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.59 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:4">
        <td
          width="295"
          style="width:221.6pt;border-top:none;border-left:none;
  border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.63</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.69 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:5">
        <td
          width="295"
          style="width:221.6pt;border-top:none;border-left:none;
  border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.77</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.89 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:6">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Forward inclination<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >+ 26°<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:7">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Backward inclination<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >- 5°<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:8">
        <td
          rowspan="2"
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Resolution<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Pan<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="295"
          style="width:221.6pt;border-top:none;border-left:none;
  border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Backward panchromatic</span
            ><span
              style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >：<span lang="EN-US"
                >0.65m<br />
                Forward panchromatic</span
              >：<span lang="EN-US">0.8m<o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:9">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >MS<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="295"
          style="width:221.6pt;border-top:none;border-left:none;
  border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Backward multispectral</span
            ><span
              style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >：<span lang="EN-US">2.6m<o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:10">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Swath Width<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >≥20 km<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:11">
        <td
          rowspan="7"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Laser Altimeter<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Laser beam<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >2 beams<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:12">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Laser repetition frequency<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >3Hz<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:13">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Range Accuracy<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >≤0.3 m (Gradient less than 15°)<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:14">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Single pulse energy<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >≤180 <span class="SpellE">mJ</span><o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:15">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Laser Wavelength<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >1.064 <span class="SpellE">μm</span><o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:16">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Facular Size<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >30 m<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:17">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Laser Divergence Angle<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >≤60 <span class="SpellE">μrad</span><o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:18">
        <td
          rowspan="4"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Sensor Footprint<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral Bands<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.50~0.72 <span class="SpellE">μm</span><br />
              1.064 <span class="SpellE">μm</span><o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:19">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Ground Pixel Resolution<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >≤4m<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:20">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Viewing field<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >+0.6° ~ +0.8°<br />
              - 0.6° ~ - 0.8°<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:21;mso-yfti-lastrow:yes">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Swath Width<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          width="336"
          colspan="2"
          style="width:251.65pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >1.6 km<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
    </table>
    <br><br>
  </div>
</template>
